import { usePageDrawer } from '@app/components/page/drawer/PageDrawerContext';
import {
  usePlaybackIsPlaying,
  usePlaybackIsSeeking,
  usePlaybackPause,
} from '@app/core/playback/hooks/usePlayback';
import { useIsActiveStationVideo } from '@app/core/stations/hooks/useIsActiveStationVideo';
import { useDownloadMediaFromSelection } from '@app/modules/logger/screens/stream/features/download-media';
import { useCanPlaySelection } from '@app/modules/logger/screens/stream/hooks/selection/useCanPlaySelection';
import {
  useCopyQuickShareURLFromSelection,
  useDownloadSelectionVideoTs,
} from '@app/modules/logger/screens/stream/hooks/selection/useSelectionActions';
import { useStreamSelection } from '@app/modules/logger/screens/stream/stores/useStreamSelection';
import { useIntl } from 'react-intl';
import { usePlaySelection } from '../../../../hooks/playback/useStreamPlayback';
import { useOpenFragmentDrawer } from '../useOpenFragmentDrawer';
import { SelectionMenuDefaultP } from './SelectionMenuDefaultP';

export function SelectionMenuDefault() {
  const isSeeking = usePlaybackIsSeeking();
  const isPlaying = usePlaybackIsPlaying();
  const pause = usePlaybackPause();
  const playSelection = usePlaySelection();
  const { $t } = useIntl();
  const isVideo = useIsActiveStationVideo();
  const { open: drawerOpen } = usePageDrawer();
  const openFragmentDrawer = useOpenFragmentDrawer();
  const { clearSelection } = useStreamSelection();
  const canPlay = useCanPlaySelection();
  const { downloadMedia, isPreparingDownload } = useDownloadMediaFromSelection();
  const downloadSelectionVideoTs = useDownloadSelectionVideoTs();
  const copyQuickShareURLFromSelection = useCopyQuickShareURLFromSelection();

  return (
    <SelectionMenuDefaultP
      loadingAudio={isSeeking}
      play={canPlay ? () => playSelection() : null}
      pause={isPlaying ? () => pause() : null}
      createFragment={drawerOpen ? null : openFragmentDrawer}
      downloadMedia={downloadMedia}
      isPreparingDownload={isPreparingDownload}
      downloadVideoTs={isVideo ? downloadSelectionVideoTs : null}
      copyQuickShareUrl={() => copyQuickShareURLFromSelection($t)}
      clear={clearSelection}
    />
  );
}
